import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import bgimage from '../../../../images/raw_material/default_rawmaterial.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Raw_Material_Add = ({ show, onClose }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [options_units, setOptionsUnits] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [optionsRawMaterialCat, setOptionsRawMaterialCat] = useState([]);
    const [selectedRawMaterialCat, setSelectedRawMaterialCat] = useState(null);
    const [selectedVendors, setSelectedVendors] = useState([]);
    const [autoPurchase, setAutoPurchase] = useState(false);  
    const [vendorCategoriesWithVendors, setVendorCategoriesWithVendors] = useState([]); 
    const [storageRooms, setStorageRooms] = useState([]);
    const [selectedStorageRoom, setSelectedStorageRoom] = useState(null);

    const [file, setFile] = useState(null);
    const imageInputRef = useRef(null);
   
    const [form, setForm] = useState({
        rawmaterial_name: '',
        brand_name: '',
        rawmaterial_quantity: '',
        expiry_period: '',
        base_cost: '',
        minimum_stock_level: '',
        maximum_stock_level: '',
        purchase_quantity: '',
        description: ''
    });

    // Error state
    const [errors, setErrors] = useState({});

    useEffect(() => {
        axios.get(`${baseURL}/manageunit/list/active`)
            .then(response => {
                const unitsOptions = response.data.data.map(unit => ({
                    value: unit.sno,
                    label: unit.unitslug_name,
                }));
                setOptionsUnits(unitsOptions);
            })
            .catch(error => {
                console.error('Error fetching units:', error);
            });
    }, [baseURL]);

    useEffect(() => {
        axios.get(`${baseURL}/list/active`)
            .then(response => {
                const rawData = response.data.data || response.data;
                const catOptions = rawData.map(cat => ({
                    value: cat.sno,
                    label: cat.rawmaterialcategory_name,
                }));
                setOptionsRawMaterialCat(catOptions);
            })
            .catch(error => console.error('Error fetching raw material categories:', error));
    }, [baseURL]);

    useEffect(() => {
        axios.get(`${baseURL}/vendor-categories-with-vendors`)
            .then(response => {
                const groupedVendorOptions = response.data.data.map(category => ({
                    label: category.category_name,
                    options: category.vendors.map(vendor => ({
                        value: vendor.vendor_id,
                        label: vendor.vendor_businessname,
                    }))
                }));
                setVendorCategoriesWithVendors(groupedVendorOptions);
            })
            .catch(error => {
                console.error('Error fetching vendor categories with vendors:', error);
            });
    }, [baseURL]);

    useEffect(() => {
    axios.get(`${baseURL}/storageroom/active/list`)
        .then(response => {
            const rooms = response.data.data.map(room => ({
                value: room.sno,
                label: room.storageroom_name
            }));
            setStorageRooms(rooms);
        })
        .catch(error => console.error('Error fetching storage rooms:', error));
    }, [baseURL]);



    const Group = (props) => (
        <components.Group {...props} />
    );

    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#333',
        }),
    };

    const handleImageChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    };

    const RemoveImage = () => {
        setFile(null);
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
    };

    const handleInputChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        // Clear error on change
        setErrors(prev => ({ ...prev, [e.target.name]: '' }));
    };

    const handleSubmit = async () => {
        // Reset errors
        let validationErrors = {};

        if (!selectedRawMaterialCat) {
            validationErrors.selectedRawMaterialCat = 'Please select a Raw Material Category.';
        }
        if (!form.rawmaterial_name.trim()) {
            validationErrors.rawmaterial_name = 'Please enter Raw Material Name.';
        }
        if (!form.rawmaterial_quantity.trim()) {
            validationErrors.rawmaterial_quantity = 'Please enter Quantity.';
        }else if (Number(form.rawmaterial_quantity) < 0) {
            validationErrors.rawmaterial_quantity = 'Quantity cannot be negative.';
        }
        if (!selectedOption) {
            validationErrors.selectedOption = 'Please select Units.';
        }
        if (!form.expiry_period.trim()) {
            validationErrors.expiry_period = 'Please enter Expiry Period.';
        }
        if (!form.base_cost.trim()) {
            validationErrors.base_cost = 'Please enter Base Cost.';
        }

        if (form.minimum_stock_level && form.maximum_stock_level) {
            if (Number(form.minimum_stock_level) > Number(form.maximum_stock_level)) {
                validationErrors.maximum_stock_level = 'Maximum Stock Level must be greater than or equal to Minimum Stock Level.';
            }
        }

        if (!selectedStorageRoom) {
            validationErrors.selectedStorageRoom = 'Please select a Storage Room.';
        }

   

        if (packedChecked && !packedGST?.value) {
            validationErrors.packed_gst = 'Please select GST for packed item.';
        }
        if (unpackedChecked && !unpackedGST?.value) {
            validationErrors.unpacked_gst = 'Please select GST for unpacked item.';
        }

        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
            return; // Stop submit if errors
        }

        try {
            const formData = new FormData();
            formData.append('rawmaterial_name', form.rawmaterial_name);
            formData.append('rawmaterial_category', selectedRawMaterialCat?.value);
            formData.append('brand_name', form.brand_name);
            formData.append('rawmaterial_quantity', form.rawmaterial_quantity);
            formData.append('rawmaterial_unit', selectedOption?.value);
            formData.append('expiry_period', form.expiry_period);
            formData.append('minimum_stock_level', form.minimum_stock_level); 
            formData.append('maximum_stock_level', form.maximum_stock_level); 
            formData.append('base_cost', form.base_cost);
            formData.append('description', form.description);
            formData.append('auto_purchase', autoPurchase ? 0 : 1);
            formData.append('room_type', selectedStorageRoom?.value);

            formData.append('created_by', user_id);
            formData.append('branch_id', branch_id);


            if (file) {
                formData.append('rawmaterial_image', file);
            } else { 
                const response = await fetch(bgimage);
                const blob = await response.blob();
                const defaultFile = new File([blob], 'default_rawmaterial.png', { type: blob.type });
                formData.append('rawmaterial_image', defaultFile);
            }

                 if (packedChecked && packedGST?.value) {
            formData.append('packed_gst', packedGST.value);
        }
        if (unpackedChecked && unpackedGST?.value) {
            formData.append('unpacked_gst', unpackedGST.value);
        }


            await axios.post(`${baseURL}/raw-materials`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
 
            onClose(); 
            window.location.reload();

        } catch (err) {
            console.error('Submission Error:', err.response?.data || err); 
        }
    };

    const navigate = useNavigate();

    const handleAddVendor = () => {
    navigate('/add-rawvendors');
    };


        const [packedChecked, setPackedChecked] = useState(true); 
        const [unpackedChecked, setUnpackedChecked] = useState(true);
    
        const [packedGST, setPackedGST] = useState(null);
        const [unpackedGST, setUnpackedGST] = useState(null);
    
        const [packedOptions, setPackedOptions] = useState([]);
        const [unpackedOptions, setUnpackedOptions] = useState([]);
    
        useEffect(() => {
            if (packedChecked) {
                axios.get(`${baseURL}/purchase-gst/active/list`, { params: { producttype: '0' } })
                    .then(res => { 

                        const options = res.data.data.map(gst => ({
                            value: gst.sno,
                            label: `${gst.gst_value}%`  
                        }));

                        setPackedOptions(options);
                    })
                    .catch(() => setPackedOptions([]));
            }
        }, [packedChecked]);
    
        useEffect(() => {
            if (unpackedChecked) {
                axios.get(`${baseURL}/purchase-gst/active/list`, { params: { producttype: '1' } })
                    .then(res => { 
                        const options = res.data.data.map(gst => ({
                            value: gst.sno,
                            label: `${gst.gst_value}%`  
                        }));

                        setUnpackedOptions(options);
                    })
                    .catch(() => setUnpackedOptions([]));
            }
        }, [unpackedChecked]);
    
    
const calculateWastageAndYield = (quantity, wastagePercent) => {
  if (!quantity || !wastagePercent) {
    setForm(prev => ({
      ...prev,
      raw_material_wastage: '',
      yield: '',
    }));
    return;
  }

  const qty = parseFloat(quantity);
  const wastage = parseFloat(wastagePercent);

  if (isNaN(qty) || isNaN(wastage) || qty === 0) {
    setForm(prev => ({
      ...prev,
      raw_material_wastage: '',
      yield: '',
    }));
    return;
  }

  const wastageAmount = (qty * wastage) / 100;
  const yieldQuantity = qty - wastageAmount;
  const yieldPercentage = (yieldQuantity / qty) * 100;

  setForm(prev => ({
    ...prev,
    raw_material_wastage: wastage.toFixed(2),
    yield: yieldPercentage.toFixed(2),  
  }));
};

 
    return (
        <Modal show={show} size="xl" >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Raw Material</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-4 mb-4">
                            <label className="text-black font-w500 fs-7">Raw Material Category<span className="required">*</span></label>
                            <Select
                                placeholder="Select Raw Material Category"
                                value={selectedRawMaterialCat}
                                onChange={value => {
                                    setSelectedRawMaterialCat(value);
                                    setErrors(prev => ({ ...prev, selectedRawMaterialCat: '' }));
                                }}
                                options={optionsRawMaterialCat}
                                components={{ Group }}
                                styles={customStyles}
                            />
                            {errors.selectedRawMaterialCat && <span className="text-danger fs-7">{errors.selectedRawMaterialCat}</span>}
                        </div> 

                        <div className="col-lg-4 mb-4">
                            <label className="text-black font-w500 fs-7">
                                Raw Material<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter Raw Material Name"
                                className="form-control"
                                name="rawmaterial_name"
                                value={form.rawmaterial_name}
                                onChange={(e) => {
                                let value = e.target.value;

                                // ✅ Allow only letters & spaces
                                value = value.replace(/[^A-Za-z\s]/g, "");

                                // ✅ Capitalize first letter of each word (keep spaces as typed)
                                value = value.replace(/\b\w/g, (char) => char.toUpperCase());

                                setForm({ ...form, rawmaterial_name: value });
                                }}
                            />
                            {errors.rawmaterial_name && (
                                <span className="text-danger fs-7">{errors.rawmaterial_name}</span>
                            )}
                        </div>
 
                        <div className="col-lg-4 mb-4">
                            <label className="text-black font-w500 fs-7">Brand</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Brand Name"
                                name="brand_name"
                                value={form.brand_name}
                                onChange={(e) => {
                                let value = e.target.value;

                                // ✅ Allow only letters & spaces
                                value = value.replace(/[^A-Za-z\s]/g, "");

                                // ✅ Capitalize first letter of each word (preserve spaces)
                                value = value.replace(/\b\w/g, (char) => char.toUpperCase());

                                setForm({ ...form, brand_name: value });
                                }}
                            />
                        </div>
 
                        <div className="col-lg-2 mb-4">
                            <label className="text-black font-w500 fs-7">
                                Quantity<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Quantity"
                                name="rawmaterial_quantity"
                                value={form.rawmaterial_quantity}
                                onChange={(e) => {
                                let value = e.target.value;

                                // ✅ Allow only digits
                                value = value.replace(/[^0-9]/g, "");

                                // ✅ Prevent negative values
                                if (value.startsWith("-")) {
                                    value = value.slice(1);
                                }

                                setForm({ ...form, rawmaterial_quantity: value });
                                }}
                            />
                            {errors.rawmaterial_quantity && (
                                <span className="text-danger fs-7">{errors.rawmaterial_quantity}</span>
                            )}
                        </div>
 
                        <div className='col-lg-2 mb-4'>
                            <label className="text-black font-w500 fs-7">Units<span className="required">*</span></label>
                            <Select
                                placeholder="Select Units"
                                value={selectedOption}
                                onChange={value => {
                                    setSelectedOption(value);
                                    setErrors(prev => ({ ...prev, selectedOption: '' }));
                                }}
                                options={options_units}
                            />
                            {errors.selectedOption && <span className="text-danger fs-7">{errors.selectedOption}</span>}
                        </div>
 
                        <div className="col-lg-4 mb-4">
                            <label className="text-black font-w500 fs-7">
                                Expiry Period (In Days)<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Expiry Period"
                                name="expiry_period"
                                value={form.expiry_period}
                                onChange={(e) => {
                                let value = e.target.value;

                                // ✅ Allow only digits
                                value = value.replace(/[^0-9]/g, "");

                                // ✅ Prevent negative sign (if pasted accidentally)
                                if (value.startsWith("-")) {
                                    value = value.slice(1);
                                }

                                setForm({ ...form, expiry_period: value });
                                }}
                            />
                            {errors.expiry_period && (
                                <span className="text-danger fs-7">{errors.expiry_period}</span>
                            )}
                        </div> 

                        <div className="col-lg-4 mb-2">
                            <div className='row mb-2'>
                                <div className="col-lg-6">
                                    <div className="form-check custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-3"
                                            id="packedCheck"
                                            checked={packedChecked}
                                            onChange={() => {
                                                setPackedChecked(!packedChecked);
                                                if (!packedChecked) setForm({ ...form, product_type: 'packed' });
                                            }}
                                        />
                                        <label className="text-black font-w500 fs-7" htmlFor="packedCheck">Packed<span className="required">*</span></label>
                                    </div>
                                    <div className={packedChecked ? 'd-block' : 'd-none'}>
                                        <div className='col-lg-12'>
                                            <Select
                                                placeholder="Select GST"
                                                value={packedGST}
                                                onChange={(option) => {
                                                    setPackedGST(option);
                                                    setErrors(prev => ({ ...prev, gst: '' }));
                                                }}
                                                options={packedOptions}
                                            />
                                            {errors.packed_gst && (
                                            <span className="text-danger fs-7">{errors.packed_gst}</span>
                                        )}


                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="form-check custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="form-check-input me-3"
                                            id="unpackedCheck"
                                            checked={unpackedChecked}
                                            onChange={() => {
                                                setUnpackedChecked(!unpackedChecked);
                                                if (!unpackedChecked) setForm({ ...form, product_type: 'unpacked' });
                                            }}
                                        />
                                        <label className="text-black font-w500 fs-7" htmlFor="unpackedCheck">Unpacked<span className="required">*</span></label>
                                    </div>
                                    <div className={unpackedChecked ? 'd-block' : 'd-none'}>
                                        <div className='col-lg-12'>
                                            <Select
                                                placeholder="Select GST"
                                                value={unpackedGST}
                                                onChange={(option) => {
                                                    setUnpackedGST(option);
                                                    setErrors(prev => ({ ...prev, gst: '' }));
                                                }}
                                                options={unpackedOptions}
                                            />
                                            {errors.unpacked_gst && (
                                                <span className="text-danger fs-7">{errors.unpacked_gst}</span>
                                            )}


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 

                        <div className="col-lg-4 mb-4">
                            <label className="text-black font-w500 fs-7">
                                Base Cost<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Base Cost"
                                name="base_cost"
                                value={form.base_cost}
                                onChange={(e) => {
                                let value = e.target.value;

                                // ✅ Allow only numbers + one decimal point
                                value = value.replace(/[^0-9.]/g, ""); 

                                // ✅ Prevent multiple decimals
                                const parts = value.split(".");
                                if (parts.length > 2) {
                                    value = parts[0] + "." + parts[1];
                                }

                                // ✅ Prevent leading decimal (".5" → "0.5")
                                if (value.startsWith(".")) {
                                    value = "0" + value;
                                }

                                // ✅ Prevent negative sign
                                if (value.startsWith("-")) {
                                    value = value.slice(1);
                                }

                                setForm({ ...form, base_cost: value });
                                }}
                            />
                            {errors.base_cost && (
                                <span className="text-danger fs-7">{errors.base_cost}</span>
                            )}
                        </div>
  
                        <div className="col-lg-4 mb-4"> 
                        <label className="text-black font-w500 fs-7">
                            Min Stock Level<span className="required">*</span>
                        </label>
                      
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Minimum Stock Level"
                            name="minimum_stock_level"
                            value={form.minimum_stock_level}
                            onChange={(e) => {
                                let value = e.target.value;
                                value = value.replace(/[^0-9]/g, ""); 
                                value = value.replace(/^0+(?=\d)/, ""); // ✅ keeps single 0
                                setForm({ ...form, minimum_stock_level: value });
                            }}
                            />

                        {errors.minimum_stock_level && (
                            <span className="text-danger fs-7">{errors.minimum_stock_level}</span>
                        )}
                        </div>

                        <div className="col-lg-4 mb-4">
                            <label className="text-black font-w500 fs-7">
                                Max Stock Level<span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                placeholder="Enter Maximum Stock Level"
                                className="form-control"
                                name="maximum_stock_level"
                                value={form.maximum_stock_level}
                                onChange={(e) => {
                                let value = e.target.value;

                                // ✅ Allow only digits
                                value = value.replace(/[^0-9]/g, "");

                                // ✅ Prevent leading zeros like "00010"
                                value = value.replace(/^0+/, "");

                                setForm({ ...form, maximum_stock_level: value });
                                }}
                            />
                            {errors.maximum_stock_level && (
                                <span className="text-danger fs-7">{errors.maximum_stock_level}</span>
                            )}
                        </div> 
                    </div>
 
                    <div className='row'> 
                        <div className='col-lg-8'>
                            <div className='d-flex flex-column'>
                                <div className='row'> 
                                    <div className='row'>
                                        <div className="col-lg-6 mb-4">
                                            <label className="text-black font-w500 fs-7">Raw Material Room<span className="required">*</span></label>
                                            <Select
                                                placeholder="Select Storage Room"
                                                value={selectedStorageRoom}
                                                onChange={value => {
                                                    setSelectedStorageRoom(value);
                                                    setErrors(prev => ({ ...prev, selectedStorageRoom: '' }));
                                                }}
                                                options={storageRooms}
                                                components={{ Group }}
                                                styles={customStyles}
                                            />
                                            {errors.selectedStorageRoom && <span className="text-danger fs-7">{errors.selectedStorageRoom}</span>}
                                        </div>

                                        <div className="col-lg-4 mb-4">
                                            <div className="form-check custom-checkbox">
                                                <input
                                                type="checkbox"
                                                checked={autoPurchase}
                                                onChange={(e) => setAutoPurchase(e.target.checked)}
                                                id="autoPurchaseCheckbox"
                                            />
                                                <label className="text-black font-w500 fs-7" htmlFor="customCheckBox1">Auto Purchase</label>
                                            </div> 
                                        </div>
                                        <div className="col-lg-9 mb-4">
                                            <label className="text-black font-w500 fs-7">Description</label>
                                            <textarea
                                            name="description"
                                            placeholder="Enter Description"
                                            className="form-control"
                                            rows={3}
                                            value={form.description}
                                            onChange={handleInputChange}
                                        />
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-4">
                            <label className="text-black font-w500 fs-7">Raw Material Image</label>
                            <div className="avatar-upload d-flex align-items-center">
                                <div className="change position-relative">
                                    <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                                        <img
                                            id="saveImageFile"
                                            src={file ? URL.createObjectURL(file) : bgimage}
                                            alt={file ? file.name : 'Default Avatar'}
                                            className="p-1 h-125px w-125px"
                                        />
                                    </div>
                                    <div className="change-btn">
                                        <input
                                            type="file"
                                            id="imageUpload"
                                            accept=".png, .jpg, .jpeg"
                                            ref={imageInputRef}
                                            style={{ display: 'none' }}
                                            onChange={handleImageChange}
                                        />
                                        <div className="mt-2 d-flex justify-content-center">
                                            <Button
                                                className="btn-xs mb-2 me-2"
                                                variant="success"
                                                onClick={() => imageInputRef.current?.click()}
                                            >
                                                <i className="fa fa-upload color-success fs-3" />
                                            </Button>
                                            <Button
                                                className="btn-xs mb-2 me-2"
                                                variant="danger"
                                                onClick={RemoveImage}
                                            >
                                                <i className="fa fa-close color-danger fs-3" />
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Button type="button" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Raw Material</Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Raw_Material_Add;
